<template>
	<div>
		<b-form inline>
			<b-input-group prepend="Couleur">
				<b-select v-model="color" :options="['non', 'oui']"></b-select>
			</b-input-group>
			<b-input-group prepend="Image">
				<b-select
					v-model="view_image"
					:options="['non', 'oui']"></b-select>
			</b-input-group>
			<b-input-group prepend="Texte">
				<b-select
					v-model="view_text"
					:options="['non', 'oui']"></b-select>
			</b-input-group>
			<b-input-group prepend="Page">
				<b-select
					v-model="document_page"
					:options="documents_page"></b-select>
			</b-input-group>
			<b-input-group
				v-show="zones_extract_list.length > 1"
				prepend="Visualiser">
				<b-select
					v-model="zone_extract"
					:options="zones_extract_list"></b-select>
			</b-input-group>
		</b-form>
		<br />
		<b-container
			style="
				margin: 0px !important;
				padding: 0px !important;
				max-width: none !important;
			">
			<b-row>
				<b-col cols="8">
					<div ref="panzoomElem">
						<panZoom
							selector=".movable"
							style="border: 1px solid; overflow: hidden"
							:options="{
								initialZoom: 1,
								bounds: false,
							}"
							@init="onInit">
							<div
								style="height: 500px; width: 2000px"
								@mousemove="handler_move($event)"
								@mouseup.right="handler_up($event)"
								@mousedown.right="handler($event)"
								@contextmenu.prevent>
								<div class="movable">
									<img
										v-if="image && view_image == 'oui'"
										:src="
											'data:image/png;base64,' + image
										" /><img />
									<div v-for="(zone, idx) in zones" :key="idx">
										<div
											v-if="zone && zone.position && zone.condition_page == page_obj.current_page && zone.condition_rotation == page_obj.rotate"
											:style="
												'position:fixed; top:' +
												zone.position.top +
												'px; left:' +
												zone.position.left +
												'px; width: ' +
												zone.position.width +
												'px; height: ' +
												zone.position.height +
												'px; background-color: blue; opacity:' + (zone.id == view_zones ? 0.25 : 0.05)
											"></div>
										<div
											v-if="zone && zone.position && zone.condition_page == page_obj.current_page && zone.condition_rotation == page_obj.rotate"
											:style="
												'position:fixed; top:' +
												zone.position.top +
												'px; left:' +
												zone.position.left +
												'px; width: ' +
												zone.position.width +
												'px; height: ' +
												zone.position.height +
												'px; font-size:10px; color: black;'">{{zone.name}}
										</div>
										<div v-for="(zone, idx) in zone.zones" :key="idx">
											<div
												v-if="zone && zone.position && zone.condition_page == page_obj.current_page && zone.condition_rotation == page_obj.rotate"
												:style="
													'position:fixed; top:' +
													zone.position.top +
													'px; left:' +
													zone.position.left +
													'px; width: ' +
													zone.position.width +
													'px; height: ' +
													zone.position.height +
													'px; background-color: red; opacity:' + (zone.id == view_zones ? 0.5 : 0.25)
												"></div>
										</div>
									</div>
									<div v-if="view_text == 'oui'">
										<div
											:id="i"
											v-html="
												item.html /*.replace(/-/g, '&#8209;')*/
											"
											v-for="(item, i) in items"
											:key="i"
											:style="
												'position:fixed;' +
												'top:' +
												item.position.top +
												'px;' +
												'bottom:' +
												item.position.bottom +
												'px;' +
												'left:' +
												item.position.left +
												'px;' +
												'right:' +
												item.position.right +
												'px;' +
												'height:' +
												(item.position.bottom -
													item.position.top) +
												'px;' +
												'width:' +
												(item.position.right -
													item.position.left) +
												'px;' +
												'font-size:' +
												(styles[item.style]
													? styles[item.style][
															'font-size'
													  ]
													: 10) +
												'px;' +
												'color:' +
												(color == 'oui'
													? styles[item.style]
														? styles[item.style][
																'font-color'
														  ]
														: 'black'
													: 'black') +
												';white-space: nowrap;'
											"
											@mouseenter="addClass"
											@mouseleave="removeClass"></div>
									</div>
									<div v-if="move">
										<div v-if="actual_x > x">
											<div
												:style="
													'position:fixed; top:' +
													abs_actual_y +
													'px; left:' +
													abs_x +
													'px; width: ' +
													(abs_actual_x - abs_x) +
													'px; height: 2px; background-color: black;'
												"></div>
											<div
												:style="
													'position:fixed; top:' +
													abs_y +
													'px; left:' +
													abs_x +
													'px; width: ' +
													(abs_actual_x - abs_x) +
													'px; height: 2px; background-color: black;'
												"></div>
										</div>
										<div v-else>
											<div
												:style="
													'position:fixed; top:' +
													abs_actual_y +
													'px; left:' +
													abs_actual_x +
													'px; width: ' +
													(abs_x - abs_actual_x) +
													'px; height: 2px; background-color: black;'
												"></div>
											<div
												:style="
													'position:fixed; top:' +
													abs_y +
													'px; left:' +
													abs_actual_x +
													'px; width: ' +
													(abs_x - abs_actual_x) +
													'px; height: 2px; background-color: black;'
												"></div>
										</div>
										<div v-if="actual_y > y">
											<div
												:style="
													'position:fixed; top:' +
													abs_y +
													'px; left:' +
													abs_x +
													'px; height: ' +
													(abs_actual_y - abs_y) +
													'px; width: 2px; background-color: black;'
												"></div>
											<div
												:style="
													'position:fixed; top:' +
													abs_y +
													'px; left:' +
													abs_actual_x +
													'px; height: ' +
													(abs_actual_y - abs_y) +
													'px; width: 2px; background-color: black;'
												"></div>
										</div>
										<div v-else>
											<div
												:style="
													'position:fixed; top:' +
													abs_actual_y +
													'px; left:' +
													abs_x +
													'px; height: ' +
													(abs_y - abs_actual_y) +
													'px; width: 2px; background-color: black;'
												"></div>
											<div
												:style="
													'position:fixed; top:' +
													abs_actual_y +
													'px; left:' +
													abs_actual_x +
													'px; height: ' +
													(abs_y - abs_actual_y) +
													'px; width: 2px; background-color: black;'
												"></div>
										</div>
									</div>
								</div>
							</div>
						</panZoom>
					</div>
				</b-col>
				<b-col cols="4">
					<b-button @click="reset">Recadrer la vue</b-button>
					<h3>Coordonnées</h3>
					<div>
						Coordonnées actuelles<br />
						X : {{ actual_x }} - Y : {{ actual_y }}
					</div>
					<h3>Zones
						<b-button @click="addZone()"
							><i class="fas fa-plus"></i
						></b-button>
					</h3>
					<div v-for="(zone, idx) in zones" :key="idx">
						<div :style="'background-color:' + (zone.id == view_zones ? 'rgb(0,255,0,0.1)' : 'rgb(0,0,0,0.0)') + '; padding: 5px; margin: 5px; border-radius: 5px;'">
							<b-input v-model="zone.name" style="display: inline-block; width:100px"/> 
							page {{zone.parameters ? zone.parameters.options.condition_page : ''}} {{zone.parameters && zone.parameters.options.condition_rotation ? ', rotation ' + zone.parameters.options.condition_rotation + '°' : ''}}
							<b-button @click="select(zone.id, idx)" variant="link"><i class="fas fa-eye"></i></b-button>
							<b-button @click="del(idx)" variant="link"><i class="fas fa-trash"></i></b-button>
							<b-button @click="addZone(idx)"  variant="link"
								><i class="fas fa-plus"></i
							></b-button>
						</div>
						<div v-for="(child_zone, child_idx) in zone.zones" :key="child_zone.id" :style="'background-color:' + (child_zone.id == view_zones ? 'rgb(0,255,0,0.1)' : 'rgb(0,0,0,0.0)') + '; padding: 5px; margin-left: 20px; margin-right: 10px;margin-top: 10px;margin-bottom: 10px; border-radius: 5px;'">
							exclusion {{child_idx + 1}}
							<b-button @click="select(child_zone.id, child_idx, idx)" variant="link"><i class="fas fa-eye"></i></b-button>
							<b-button @click="del(child_idx, idx)" variant="link"><i class="fas fa-trash"></i></b-button>
						</div>
					</div>
				</b-col>
			</b-row>
		</b-container>
		<br />
		<b-container v-show="false" :style="'margin: 0; padding: 0; max-width: none;'">
			<b-row ref="div_row" style="margin: 0; padding: 0; max-width: none">
				<b-col ref="div_menu" md="auto" style="margin: 0; padding: 0; max-width: none">
					<div>
						Zones
						<i class="fas fa-plus-square" @click="addZone()"></i>
					</div>
					<document_extraction_tree
						:level="0"
						:zones="zones"
						:view="view_zones"
						@select="select"
						@add="addZone"></document_extraction_tree>
				</b-col>
				<b-col>
					<div v-for="(zone, idx) in zones" :key="zone.id">
						<div v-show="zone.id == view_zones">
							<document_extraction_zone
								:ref="'document_extraction_zone' + zone.id"
								:start_name="zone.load ? false : 'zone ' + idx"
								:projects="projects"
								:projects_options="projects_options"
								:results_arr="results_arr"
								:size="size"
								@update="update(zone.id, null, ...arguments)">
							</document_extraction_zone>
						</div>
						<div v-for="(child_zone, child_idx) in zone.zones" :key="child_zone.id">
							<document_extraction_zone
								:ref="'document_extraction_zone' + child_zone.id"
								:start_name="zone.load ? false : 'zone ' + child_idx"
								:projects="projects"
								:projects_options="projects_options"
								:results_arr="results_arr"
								:size="size"
								@update="update(child_zone.id, idx, ...arguments)">
							</document_extraction_zone>
						</div>
					</div>
				</b-col>
			</b-row>
		</b-container>
		<div v-if="spinner" class="center_spinner">
			<fade-loader></fade-loader>
		</div>
	</div>
</template>

<script>
	import pdf from "vue-pdf";
	import draggable from "vuedraggable";
	import uniqueId from "lodash.uniqueid";
	import { JSONEditor } from "@json-editor/json-editor";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";
	
	import store from "../store";
	import workers from "../services/workers.js";
	import documents_componenent from "../views/Document.vue";
	import viewFile from "../components/viewFile.vue";
	import treatments from "../services/treatments.js";
	import edit_tabulator from "../components/edit_tabulator.vue";
	import document_extraction_zone from "../components/document_extraction_zone.vue";
	import document_extraction_tree from "../components/document_extraction_tree.vue";
	import document_extraction_post_treatment from "../components/document_extraction_post_treatment.vue";

	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	var clone = require("clone");

	export default {
		name: "document_extraction_parameters_page",
		components: {
			pdf,
			viewFile,
			draggable,
			FadeLoader,
			edit_tabulator,
			documents_componenent,
			document_extraction_zone,
			document_extraction_tree,
			document_extraction_post_treatment
		},
		props: {
			column_name: {
			},
			projects: {
				default: () => [],
			},
			projects_options: {
				default: () => [],
			},
			document_extraction: {
				default: () => []
			},
			document_extraction_type: {
				default: () => {}
			},
			inter_page: false
		},
		data() {
			return {
				id: uniqueId(""),
				size: 0,
				relative: false,
				move: false,
				name_zone: "",
				color: "oui",
				view_image: "oui",
				view_text: "oui",
				spinner: false,
				results: {},
				name: "",
				page: 0,
				url_pdf: "",
				url_image: "",
				image: "",
				panzoomInstance: null,
				items: [],
				styles: {},
				target: -1,
				item: null,
				x: 0,
				actual_x: 0,
				y: 0,
				actual_y: 0,
				abs_x: 0,
				abs_actual_x: 0,
				abs_y: 0,
				abs_actual_y: 0,
				e: null,
				zones: [
				],
				zone: null,
				view_zones: "",
				documents: {},
				documents_name: [],
				document_name: "",
				documents_page: [],
				document_page: "",

				zone_extract: "",
				zones_extract: {},
				zones_extract_list: [],

				results_arr: [],
				post_treatment_logs: [],
				columns: [],
				type_column: "",

				tabIndex: 0,

				mapping: false,
				mapping_columns: [],

				test_logs: [],
				rotate: 0,
				page_obj: {}
			};
		},
		watch: {
			view_zones: async function () {
				this.zone = null;
				console.log(this.view_zones)
				for (var i = 0; i < this.zones.length; i++) {
					if (this.view_zones == this.zones[i].id) {
						this.zone = this.zones[i];
						break;
					}
				}
			},
			document_page: async function () {
				this.name = this.document_name;
				var keys = Object.keys(
					this.documents[this.document_name].pages
				);
				this.page = this.document_page - 1;
				this.items = [];

				this.page_obj = this.documents[this.document_name].pages[
						keys[this.document_page - 1]
					];
				console.log("document_page");
				console.log(this.page_obj);
				var keys_items = Object.keys(
					this.documents[this.document_name].pages[
						keys[this.document_page - 1]
					].items
				);
				for (var i = 0; i < keys_items.length; i++) {
					var item =
						this.documents[this.document_name].pages[
							keys[this.document_page - 1]
						].items[keys_items[i]];
					this.items.push(item);
				}

				this.zone_extract = "";
				this.zones_extract_list = [""];
				var keys_zones = Object.keys(this.zones_extract);
				for (var i = 0; i < keys_zones.length; i++) {
					if (this.zones_extract[keys_zones[i]].attributes.nb_page == this.document_page)
						this.zones_extract_list.push(keys_zones[i]);
				}

				this.url_image =
					this.documents[this.document_name].pages[
						keys[this.document_page - 1]
					].url_image;

				this.image = "";
				if (this.url_image) {
					var image = await treatments.getFileAlyx(
						this.url_image,
						false,
						"arraybuffer"
					);
					this.image = this._arrayBufferToBase64(image);
				}

				this.reset();
			},
			document_name: async function () {
				this.change_document();
			},

		},
		methods: {
			async del(idx, parent_idx = null)
			{
				if (parent_idx == null)
					this.zones.splice(idx, 1);
				else
					this.zones[parent_idx].zones.splice(idx, 1);
			},
			async change_document()
			{
				this.documents_page = [];
				this.document_page = 1;
				var keys = Object.keys(
					this.documents[this.document_name].pages
				);
				for (var i = 0; i < keys.length; i++) {
					this.documents_page.push({value: i + 1, text: this.documents[this.document_name].pages[keys[i]].current_page + (this.documents[this.document_name].pages[keys[i]].rotate ? " - rotation : " + this.documents[this.document_name].pages[keys[i]].rotate : "" )});
				}

				var keys = Object.keys(
					this.documents[this.document_name].pages
				);
				this.page = this.document_page - 1;
				this.items = [];

				var keys_items = Object.keys(this.documents[this.document_name].pages[keys[this.document_page - 1]].items);
				for (var i = 0; i < keys_items.length; i++) 
				{
					var item = this.documents[this.document_name].pages[keys[this.document_page - 1]].items[keys_items[i]];
					this.items.push(item);
				}

				this.styles = this.documents[this.document_name].styles;
				this.url_pdf = this.documents[this.document_name].pages[keys[this.document_page - 1]].url_pdf || "";
				this.url_image = this.documents[this.document_name].pages[keys[this.document_page - 1]].url_image;

				this.zone_extract = "";
				this.zones_extract = {};
			
				this.image = "";
				if (this.url_image) 
				{
					var image = await treatments.getFileAlyx(this.url_image, false, "arraybuffer");
					this.image = this._arrayBufferToBase64(image);
				}

				this.reset();
			},
			select_file(files, column)
			{
				console.log(files)
				var arr = []
				for (var i = 0; i < files.length; i++)
				{
					arr.push(files[i].libelle.replace(/\.[^/.]+$/g, ""))
				}
				column.files = files;
				column.value = arr;
			},
			add_columns(arr)
			{
				if (arr.length == 0)
					return arr;

				var line = arr[0];
				var keys = Object.keys(line);

				for (var j = 0; j < this.mapping_columns.length; j++)
				{
					this.mapping_columns[j].exemple = "";
				}

				for (var i = 0; i < keys.length; i++)
				{
					var c = true;
					for (var j = 0; j < this.mapping_columns.length; j++)
					{
						if (keys[i] == this.mapping_columns[j].colonne)
						{
							this.mapping_columns[j].exemple = line[keys[i]];
							c = false;
							break;
						}
					}
					if (c)
					{
						this.mapping_columns.push({
							"colonne": keys[i],
							"mapping": keys[i],
							"exemple": line[keys[i]],
							"text": ""
						})
					}
				}
			},
			remove_mapping(idx)
			{
				this.mapping_columns.splice(idx, 1);
			},
			add_mapping()
			{
				this.mapping_columns.push({
					"colonne": "",
					"mapping": "",
					"exemple": "",
					"text": ""
				})
			},
			remove_column(idx)
			{
				this.columns.splice(idx, 1);
			},
			change_type_column: function(idx) 
			{
				var type_column = this.columns[idx].type_column;

				for (var i = 0; i < this.document_extraction.length; i++)
				{
					if (type_column == this.document_extraction[i].value)
					{
						this.columns[idx].type = this.document_extraction[i].type;
					}
				}
			},
			add_column: function(type_column)
			{
				var column = {
					column: "",
					type: "",
					value: ""
				};

				var obj = null;

				if (type_column)
				{
					this.type_column = type_column;
				}

				console.log("add_column")
				console.log(this.type_column)

				if (this.type_column)
				{
					for (var i = 0; i < this.document_extraction.length; i++)
					{
						if (this.type_column == this.document_extraction[i].value)
							obj = this.document_extraction[i];
					}
				}

				if (obj)
				{
					column = {
						column: obj.column,
						type: obj.type,
						type_column: this.type_column,
						value: ""
					}
				}

				this.columns.push(column);

				this.type_column = "";
			},
			_arrayBufferToBase64(buffer) {
				var binary = "";
				var bytes = new Uint8Array(buffer);
				var len = bytes.byteLength;
				for (var i = 0; i < len; i++) {
					binary += String.fromCharCode(bytes[i]);
				}
				return window.btoa(binary);
			},
			get_tree_node(zones, child_zones) {
				for (var i = 0; i < child_zones.length; i++) {
					var zone = this.$refs[
						"document_extraction_zone" + child_zones[i].id
					][0].save();
					zone.id = child_zones[i].id;
					zone.level = child_zones[i].level;
					zone.zones = [];
					if (child_zones[i].zones.length > 0)
						this.get_tree_node(
							zone.zones,
							child_zones[i].zones
						);
					zones.push(zone);
				}
			},
			get_tree() {
				var zones = [];

				for (var i = 0; i < this.zones.length; i++) {
					if (this.zones[i].level == 0) {
						var zone = this.$refs[
							"document_extraction_zone" + this.zones[i].id
						][0].save();
						zone.id = this.zones[i].id;
						zone.parameters.name = this.zones[i].name;
						zone.name = this.zones[i].name;
						zone.level = this.zones[i].level;
						zone.condition_page = this.zones[i].condition_page;
						zone.condition_rotation = this.zones[i].condition_rotation;
						if (!zone.parameters.type)
							zone.parameters.type = {};
						zone.parameters.type.type = "html complet";
						zone.zones = [];
						if (this.zones[i].zones.length > 0)
						{
							this.get_tree_node(
								zone.zones,
								this.zones[i].zones
							);
							for (var j = 0; j < zone.zones.length; j++)
							{
								zone.zones[j].name = zone.name;
								zone.zones[j].parameters.name = zone.name;
							}
							console.log(zone.zones)
							var sub_zone = clone(zone);
							sub_zone.level = 1;
							sub_zone.zones = [];
							zone.zones.push(sub_zone);
						}
						zones.push(zone);
					}
				}

				return zones;
			},
			save() {
				var data = {
					zones: [],
					relative: this.relative,
					columns: this.columns
				};

				data.zones = this.get_tree();

				return data;
			},
			async load_zone(zones, level = 0) {
				//console.log("load zones")
				//console.log(clone(zones))
				for (var i = 0; i < zones.length; i++) {

					if (zones[i].parameters.options.condition_page)
						zones[i].parameters.options.condition_page = parseInt(zones[i].parameters.options.condition_page);
					if (zones[i].parameters.options.condition_rotation)
						zones[i].parameters.options.condition_rotation = parseInt(zones[i].parameters.options.condition_rotation);

					var zone = {
						id: uniqueId(),
						name: zones[i].name,
						level: zones[i].level || 0,
						zones: zones[i].zones || [],
						parameters: zones[i].parameters || {},
						position: zones[i].position || null,
						position_parent: zones[i].position_parent || null,
						project_id: zones[i].project_id || "",
						project: zones[i].project || null,
						params: zones[i].params || null,
						load: true
					};
					if (level == 0)
						this.zones.push(zone);
					zones[i] = zone;
					//zones[i].id = zone.id;
					if (zones[i].zones && zones[i].zones.length > 0)
						this.load_zone(zones[i].zones, 1);
				}
			},
			async load(data) {
				var self = this;
				this.zones = [];

				var zones = [];

				for (var i = 0; i < data.zones.length; i++)
				{
					if (data.zones[i].zones && data.zones[i].zones.length > 0)
						data.zones[i].zones.pop()
				}

				await this.load_zone(data.zones);

				console.log("load page")
				console.log(clone(this.zones))

				this.relative = data.relative || false;

				this.view_zones = this.zones[0].id;
				this.name_zone = this.zones[0].name;

				//console.log("data.columns")
				//console.log(JSON.stringify(data.columns))

				var columns = clone(data.columns);

				this.columns = data.columns || [];

				this.mapping = data.mapping || false;
				this.mapping_columns = data.mapping_columns || [];

				if (data.document_extraction_post_treatment)
					await this.$refs.document_extraction_post_treatment.load(data.document_extraction_post_treatment);

				self.$nextTick(async function () {

					console.log("load page 1")
					console.log(clone(self.zones))

					for (var i = 0; i < self.zones.length; i++) {
						await self.$refs["document_extraction_zone" + self.zones[i].id][0].load(self.zones[i]);
						for (var j = 0; j < self.zones[i].zones.length; j++)
						{
							await self.$refs["document_extraction_zone" + self.zones[i].zones[j].id][0].load(self.zones[i].zones[j]);
						}
					}

					console.log("load page 2")
					console.log(clone(self.zones))

					for (var i = 0; i < self.columns.length; i++)
					{
						self.columns[i].value = columns[i].value;
						if (columns[i].files)
						{
							self.$refs["documents-" + i][0].load_data_files_desc(columns[i].files);
						}
					}

					console.log("load page 3")
					console.log(clone(self.zones))
				});
			},
			async update_node(id, data, zones) {
				for (var i = 0; i < zones.length; i++) {
					if (zones[i].id == id) {
						zones[i].name = data.name;
						(this.name_zone = data.name),
							this.$set(zones, i, zones[i]);
						if (zones[i].zones.length > 0)
							await this.update_node(id, data, zones.zones);
					}
				}
			},
			async update(id, parent_idx = null, data) {
				console.log("update")
				var zones = this.zones;
				if (parent_idx != null)
					zones = zones[parent_idx].zones;
				for (var i = 0; i < zones.length; i++) {
					if (zones[i].id == id) {
						if (!zones[i].name)
							zones[i].name = data.name;
						zones[i].parameters = data;
						this.name_zone = data.name;
						if (zones[i].hasOwnProperty("condition_page"))
							zones[i].parameters.options.condition_page = zones[i].condition_page;
						if (zones[i].hasOwnProperty("condition_rotation"))
							zones[i].parameters.options.condition_rotation = zones[i].condition_rotation;
						zones[i].parameters.options.condition_page = parseInt(zones[i].parameters.options.condition_page);
						zones[i].condition_page = zones[i].parameters.options.condition_page;
						zones[i].parameters.options.condition_rotation = parseInt(zones[i].parameters.options.condition_rotation);
						zones[i].condition_rotation = zones[i].parameters.options.condition_rotation;
						if (zones[i].parameters.limit.length > 0 && zones[i].parameters.limit[0].type == 'block')
						{
							zones[i].position = {
								top: zones[i].parameters.limit[0].y1,
								left: zones[i].parameters.limit[0].x1,
								width: zones[i].parameters.limit[0].x2 - zones[i].parameters.limit[0].x1, 
								height: zones[i].parameters.limit[0].y2 - zones[i].parameters.limit[0].y1
							}
						}
						this.$set(zones, i, zones[i]);
					}
					if (zones[i].zones && zones[i].zones.length > 0)
						await this.update_node(id, data, zones[i].zones);
				}
				var zones = await this.get_tree();
				this.$emit("update", zones);
			},
			update_name(new_name) {
				var params =
					this.$refs[
						"document_extraction_zone" + this.view_zones
					][0].getParams();
				params.name = new_name;
				this.$refs[
					"document_extraction_zone" + this.view_zones
				][0].setParams(params);
			},
			select(id, idx = -1, idx_parent = null) {
				var zone_parent = this.zones;
				if (idx_parent != null)
					zone_parent = this.zones[idx_parent].zones;
				this.view_zones = id;
				if (idx >= 0)
				{
					var keys = Object.keys(this.documents[this.document_name].pages);
					for (var i = 0; i < keys.length; i++)
					{
						if (zone_parent[idx].condition_page == this.documents[this.document_name].pages[keys[i]].current_page && 
							zone_parent[idx].condition_rotation == this.documents[this.document_name].pages[keys[i]].rotate)
						{
							this.document_page = i + 1;
						}
					}
				}
			},
			setDocuments: function (documents) {
				this.documents = documents;
				this.documents_name = Object.keys(this.documents);
				if (this.documents_name.length > 0)
					this.document_name = this.documents_name[0];

				this.change_document();
			},
			addZoneTree(zones, zone_add, ids) {
				var id = ids.shift();
				var zone = null;
				for (var i = 0; i < zones.length; i++) {
					if (zones[i].id == id) {
						zone = zones[i];
						break;
					}
				}
				if (ids.length > 0) {
					this.addZoneTree(zone.zones, zone_add, ids);
				} else {
					zone_add.position = zone.position || null;
					zone_add.position_parent = zone.position || null;
					if (!zone_add.parameters)
					{
						zone_add.parameters = {
							options: {}
						}
					}
					zone_add.parameters.options.condition_page = zone.parameters.options.condition_page;
					if (zone.parameters.options.condition_rotation || zone.parameters.options.condition_rotation == 0)
						zone_add.parameters.options.condition_rotation = zone.parameters.options.condition_rotation;
					zone.zones.push(zone_add);
				}
			},
			addZone: async function (parent_idx = null) {

				var zone_parent = this.zones;
				var level = 0;
				if (parent_idx != null)
				{
					zone_parent = this.zones[parent_idx].zones;
					level = 1;
				}

				var id = uniqueId("");

				var zone = {
					id: id,
					zones: [],
					level: level,
					condition_page: this.page_obj.current_page,
					condition_rotation: this.page_obj.rotate
				};

				if (parent_idx != null)
				{
					zone.position_parent = this.zones[parent_idx].position
				}

				zone_parent.push(zone);
				this.view_zones = zone_parent[zone_parent.length - 1].id;
				this.name_zone = zone_parent[zone_parent.length - 1].name;
			},
			removeZone(zones, ids, id, remove) {
				for (var i = 0; i < zones.length; i++) {
					if (zones[i].zones.length > 0) {
						if (zones[i].id == id)
							this.removeZone(zones[i].zones, ids, id, true);
						else this.removeZone(zones[i].zones, ids, id, remove);
					}
					if (zones[i].id == id || remove) {
						ids.push(zones[i].id);
						if (zones[i].level) {
							zones.splice(i, 1);
							i--;
						}
					}
				}
			},
			async removeAt(idx) {
				var zone = this.zones[idx];
				var ids = [];

				this.removeZone(this.zones, ids, zone.id, false);

				for (var i = 0; i < this.zones.length; i++) {
					if (ids.includes(this.zones[i].id)) {
						this.zones.splice(i, 1);
						i--;
					}
				}
				if (this.zones.length > 0) {
					this.view_zones = this.zones[this.zones.length - 1].id;
					this.name_zone = this.zones[this.zones.length - 1].name;
				}
				var zones = await this.get_tree();
				this.$emit("update", zones);
			},
			set_zones_extract(zones_extract, level, prefix) {
				var keys = Object.keys(zones_extract);
				for (var i = 0; i < keys.length; i++) {
					if (level > 0) {
						this.zones_extract[prefix + "-" + keys[i]] =
							zones_extract[keys[i]];
					}
					if (zones_extract[keys[i]].zones) {
						this.set_zones_extract(
							zones_extract[keys[i]].zones,
							level + 1,
							prefix ? prefix + "-" + keys[i] : keys[i]
						);
					}
				}
			},
			get_project(uid) {

				// console.log(this.project_id)
				for (var i = 0; i < this.projects.length; i++) {
					if (this.projects[i].uid == uid) {
						return this.projects[i];
					}
				}
			},
			async set_zones_extract_test()
			{
				this.set_zones_extract(this.zones_extract, 0, "");

				this.zones_extract_list = [""];
				var keys = Object.keys(this.zones_extract);
				for (var i = 0; i < keys.length; i++) {
					if (this.zones_extract[keys[i]].attributes.nb_page == this.document_page)
						this.zones_extract_list.push(keys[i]);

					if (
						this.zones_extract[keys[i]].position_absolute.top ==
							null ||
						this.zones_extract[keys[i]].position_absolute.top < 0
					)
						this.zones_extract[keys[i]].position_absolute.top = 0;
					if (
						this.zones_extract[keys[i]].position_absolute.left ==
							null ||
						this.zones_extract[keys[i]].position_absolute.left < 0
					)
						this.zones_extract[keys[i]].position_absolute.left = 0;
					if (
						this.zones_extract[keys[i]].position_absolute.bottom ==
							null ||
						this.zones_extract[keys[i]].position_absolute.bottom >
							10000
					)
						this.zones_extract[
							keys[i]
						].position_absolute.bottom = 10000;
					if (
						this.zones_extract[keys[i]].position_absolute.right ==
							null ||
						this.zones_extract[keys[i]].position_absolute.right >
							10000
					)
						this.zones_extract[
							keys[i]
						].position_absolute.right = 10000;
					this.zones_extract[keys[i]].position_absolute.height =
						this.zones_extract[keys[i]].position_absolute.bottom -
						this.zones_extract[keys[i]].position_absolute.top;
					this.zones_extract[keys[i]].position_absolute.width =
						this.zones_extract[keys[i]].position_absolute.right -
						this.zones_extract[keys[i]].position_absolute.left;
				}

				await this.set_positions(this.zones, "", null);

				if (!this.zones_extract_list.includes(this.zone_extract))
					this.zone_extract = "";
			},
			async set_positions(zones, parent, position_parent, condition_page = null, condition_rotation = null) {
				for (var i = 0; i < zones.length; i++) {
					var name = parent + (parent ? "-" : "") + zones[i].name;
					if (this.zones_extract[name]) {
						zones[i].position =
							this.zones_extract[name].position_absolute;
						zones[i].position_parent = position_parent;
						if (condition_page !== null)
							zones[i].parameters.options.condition_page = condition_page;
						if (condition_rotation !== null)
							zones[i].parameters.options.condition_rotation = condition_rotation;
						this.$refs[
							"document_extraction_zone" + zones[i].id
						][0].setPosition(
							zones[i].position,
							zones[i].position_parent
						);
						if (zones[i].zones) {
							await this.set_positions(
								zones[i].zones,
								name,
								zones[i].position,
								zones[i].parameters.options.condition_page,
								zones[i].parameters.options.condition_rotation
							);
						}
					}
				}
			},
			addLimit: function (limit) {
				this.$refs["document_extraction_zone" + this.view_zones][0].addLimit(limit);
				for (var i = 0; i < this.zones.length; i++)
				{
					if (this.zones[i].id == this.view_zones)
					{
						this.zones[i].condition_page = this.page_obj.current_page;
						this.zones[i].condition_rotation = this.page_obj.rotate;
					}
				}
			},
			addClass: function (e) {
				this.target = e.target.id;
				//e.target.classList.add("hovered");
			},
			removeClass: function (e) {
				this.target = -1;
				e.target.classList.remove("hovered");
			},
			setMeta(name, page, url_pdf, rotate) {
				this.name = name;
				this.page = page;
				this.url_pdf = url_pdf || "";
				this.rotate = rotate || 0;
			},
			setItems(items) {
				this.items = items;
			},
			setStyle(styles) {
				this.styles = styles;
			},
			handler_up: function (e) {
				var left =
					e.clientX -
					this.$refs.panzoomElem.getBoundingClientRect().left;
				var top =
					e.clientY -
					this.$refs.panzoomElem.getBoundingClientRect().top;
				var pos = this.panzoomInstance.getTransform();
				left = (left / pos.scale - pos.x / pos.scale) * 1;
				top = (top / pos.scale - pos.y / pos.scale) * 1;
				var x = Math.round(left);
				if (this.relative && this.zone.position_parent)
					x -= this.zone.position_parent.left;
				var y = Math.round(top);
				if (this.relative && this.zone.position_parent)
					y -= this.zone.position_parent.top;

				if (x != this.x && y != this.y) {
					var x1 = 0;
					var x2 = 0;
					var y1 = 0;
					var y2 = 0;
					if (this.x > x) {
						x1 = x;
						x2 = this.x;
					} else {
						x1 = this.x;
						x2 = x;
					}
					if (this.y > y) {
						y1 = y;
						y2 = this.y;
					} else {
						y1 = this.y;
						y2 = y;
					}
					this.addLimit({
						type: "block",
						x1: x1,
						y1: y1,
						x2: x2,
						y2: y2,
						relative: this.relative,
					});
				}
				this.move = false;
			},
			handler_move: function (e) {
				var left =
					e.clientX -
					this.$refs.panzoomElem.getBoundingClientRect().left;
				var top =
					e.clientY -
					this.$refs.panzoomElem.getBoundingClientRect().top;
				var pos = this.panzoomInstance.getTransform();
				left = (left / pos.scale - pos.x / pos.scale) * 1;
				top = (top / pos.scale - pos.y / pos.scale) * 1;
				this.actual_x = Math.round(left);
				this.abs_actual_x = this.actual_x;
				if (this.relative && this.zone.position_parent)
					this.actual_x -= this.zone.position_parent.left;
				this.actual_y = Math.round(top);
				this.abs_actual_y = this.actual_y;
				if (this.relative && this.zone.position_parent)
					this.actual_y -= this.zone.position_parent.top;
			},
			handler: function (e) {
				var left =
					e.clientX -
					this.$refs.panzoomElem.getBoundingClientRect().left;
				var top =
					e.clientY -
					this.$refs.panzoomElem.getBoundingClientRect().top;
				var pos = this.panzoomInstance.getTransform();
				left = (left / pos.scale - pos.x / pos.scale) * 1;
				top = (top / pos.scale - pos.y / pos.scale) * 1;
				this.x = Math.round(left);
				this.abs_x = this.x;
				if (this.relative && this.zone.position_parent)
					this.x -= this.zone.position_parent.left;
				this.y = Math.round(top);
				this.abs_y = this.y;
				if (this.relative && this.zone.position_parent)
					this.y -= this.zone.position_parent.top;
				if (this.e) this.e.target.classList.remove("selected");
				if (this.target > -1) {
					this.item = this.items[this.target];
					this.e = e;
					//e.target.classList.add("selected");
				} else {
					this.e = null;
					this.item = null;
				}

				this.move = true;
			},
			reset() {
				this.panzoomInstance.zoomAbs(0, 0, 1);
				this.panzoomInstance.moveTo(0, 0);
			},
			onInit: function (panzoomInstance, id) {
				this.panzoomInstance = panzoomInstance;
				//this.panzoomInstance.zoomTo(0, 0, 2);
			},
			onResize() {
				if (this.$refs.div_row)
					this.size =
						this.$refs.div_row.clientWidth -
						this.$refs.div_menu.clientWidth;
			},
		},
		mounted: async function () {
			var self = this;

			this.ro = new ResizeObserver(this.onResize).observe(
				this.$refs.div_row
			);

			self.$nextTick(function () {
				self.size =
					self.$refs.div_row.clientWidth -
					self.$refs.div_menu.clientWidth;
			});

			console.log("document_extraction")
			if (this.document_extraction)
			{
				console.log("document_extraction")
				console.log(this.document_extraction)
				for (var i = 0; i < this.document_extraction.length; i++)
				{
					console.log(this.document_extraction[i])
					if (this.document_extraction[i].start)
						this.add_column(this.document_extraction[i].value)
				}
			}

		},
	};
</script>

<style scoped>
	.hovered {
		text-decoration: none;
		cursor: crosshair;
	}
	.selected {
		text-decoration: none;
		cursor: crosshair;
	}
</style>
